<ion-chip
  *ngIf="qualityBonus"
  [color]="getQualityBonusClass(qualityBonus)"
  [outline]="inactive"
>
  {{ getQualityBonusTranslate(qualityBonus) | translate }}
</ion-chip>
